export const container = ({ theme: { colors } }) => ({
    background: colors.darkGrey,
    color: colors.white,
    paddingLeft: '0.3125rem',
    paddingRight: '0.3125rem',
    paddingTop: '0.1rem',
    paddingBottom: '0.1125rem',
    marginRight: '0.5625rem',
    display: 'inline-block',
    fontWeight: 600,
});
